import React from "react";
import { Link } from "react-router-dom";
import './product_sstyle.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min';
import 'aos/dist/aos.css';
import 'bootstrap/dist/css/bootstrap.min.css';

import 'react-medium-image-zoom/dist/styles.css';

function Footer() {
    return (
<>
<section className="home-bg-in">
  <p className="footer">{new Date().getFullYear()} | ABLEPRO SOLUTIONS PVT. LTD. | <Link className="nav-item-footer" spy="true" to="/privacy-policy">PRIVACY POLICY</Link> | <Link className="nav-item-footer" spy="true" to="/terms-of-use">TERMS OF USE</Link> </p>
</section>
</>
)
}

export default Footer
